"use client"

import { HttpTypes } from "@medusajs/types"
import ProductCardForRelated from "@/modules/products/components/product-card-for-related"

type BestsellersCarouselProps = {
  products: HttpTypes.StoreProduct[]
  region: HttpTypes.StoreRegion
  countryCode: string
  productCount: number
  cardClasses: string
}

export default function BestsellersCarousel({
  products,
  region,
  countryCode,
  cardClasses,
}: BestsellersCarouselProps) {
  if (products.length === 0) {
    return null
  }

  return (
    <div className="relative">
      <ul className="flex gap-4 overflow-x-auto pb-2 snap-x snap-mandatory scroll-smooth no-scrollbar">
        {products.map((product, index) => (
          <li
            key={product.id ?? product.handle ?? `product-${index}`}
            className={`${cardClasses} snap-start flex-shrink-0`}
          >
            <ProductCardForRelated
              product={product}
              region={region}
              countryCode={countryCode}
            />
          </li>
        ))}
      </ul>
    </div>
  )
}
